// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SAPPVideo_wrapper___EhGW","hideWrapper":"SAPPVideo_hideWrapper__l48rL","content":"SAPPVideo_content__FC9Oj"};